import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import modalview from "./modalview";
import loader from "./loader";
import menu from "./menu";
import messageSlice from 'redux/messageSlice';
/*
export default combineReducers({
  auth,message,modalview,loader, menu, messageSlice
});
*/
const chat = messageSlice.reducer;
export default combineReducers({
  auth,message,modalview,loader, menu, chat
});
